import { render, staticRenderFns } from "./SettingRouteDrawer.vue?vue&type=template&id=31c54b7e&scoped=true"
import script from "./SettingRouteDrawer.vue?vue&type=script&lang=js"
export * from "./SettingRouteDrawer.vue?vue&type=script&lang=js"
import style0 from "./SettingRouteDrawer.vue?vue&type=style&index=0&id=31c54b7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c54b7e",
  null
  
)

export default component.exports